import { DeleteButton } from "@/shared/form/button";
import { useMutation } from "@apollo/client";
import { REMOVE_DYNAMIC_PROCESS_MODEL } from "../../api/remove-dynamic-process-model/remove-dynamic-process-model";
import { useNotification } from "@/shared/feedback/notification";
import { GET_ALL_DYNAMIC_PROCESSES } from "@/modules/admin-panel/dynamic-processes/entities/dynamic-processes-list/api/get-all-dynamic-processes";
import { useTranslations } from "use-intl";

export function RemoveDynamicProcessButton({ id }: { id: string }) {
  const [remove] = useMutation(REMOVE_DYNAMIC_PROCESS_MODEL, {
    refetchQueries: [GET_ALL_DYNAMIC_PROCESSES],
  });
  const notify = useNotification();
  const t = useTranslations("RemoveDynamicProcessButton");

  return (
    <DeleteButton
      onClick={async () => {
        const response = await remove({
          variables: { id },
        });

        if (response.data?.removeDynamicProcessById) {
          notify?.success({
            message: t("Dynamic process removed successfully"),
          });
        }
      }}
    />
  );
}
